// extracted by mini-css-extract-plugin
export default {"formContainer":"manual_add_shortlist_formContainer__VLKgX","formstyling":"manual_add_shortlist_formstyling__Dc+ba"};